/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_Ask_TrainerInputs */

const en_us2_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your trainer`)
};

const pt_br2_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao personal`)
};

const es_419_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar al entrenador`)
};

const pt_pt2_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao treinador`)
};

const fr_fr2_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander au coach`)
};

const de_de2_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach fragen`)
};

const it_it2_today_checkin_ask_trainer = /** @type {(inputs: Today_Checkin_Ask_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi al coach`)
};

/**
* | output |
* | --- |
* | "Ask your trainer" |
*
* @param {Today_Checkin_Ask_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_ask_trainer = /** @type {((inputs?: Today_Checkin_Ask_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Ask_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_ask_trainer(inputs)
	if (locale === "es-419") return es_419_today_checkin_ask_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_ask_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_ask_trainer(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_ask_trainer(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_ask_trainer(inputs)
	return en_us2_today_checkin_ask_trainer(inputs)
});
export { today_checkin_ask_trainer as "today.checkin_ask_trainer" }